import { LoadState } from "../../constants/enums";
import { IGenAiPrompt, IGenAiContext, IGenAiState } from "./genAi.types";

export const defaultGenAiPrompt: IGenAiPrompt = {
  genai_prompt_uuid: null,
  company_name: "",
  collection_name: "",
  prompt: "",
  prompt_key: "",
  company_outlet_uuid: null,
  status: "ACTIVE",
};

export const defaultGenAiContext: IGenAiContext = {
  genai_context_uuid: null,
  section: "",
  content: "",
  category: "",
  context_key: null,
  document_id: null,
  collection_name: null,
  status: "ACTIVE",
  company_outlet_uuid: null,
  company_name: null,
};

export const defaultGenAiState: IGenAiState = {
  prompt: {
    list: {
      data: [],
      totalRecords: 0,
      currentRecords: 0,
      loading: LoadState.InProgress,
      error: null,
    },
    prompt: {
      data: defaultGenAiPrompt,
      loading: LoadState.NotLoaded,
      error: null,
    },
  },
  context: {
    list: {
      data: [],
      totalRecords: 0,
      currentRecords: 0,
      loading: LoadState.InProgress,
      error: null,
    },
    context: {
      data: defaultGenAiContext,
      loading: LoadState.NotLoaded,
      error: null,
    },
  },
};
